import { Link } from "react-router-dom";
import { UserPlus, CheckSquare, ClipboardList } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const ITEMS = [
  { to: "/tasks", icon: CheckSquare, key: "qaTask", testId: "quick-add-task" },
  { to: "/leads", icon: UserPlus, key: "qaLead", testId: "quick-add-lead" },
  { to: "/buyers", icon: UserPlus, key: "qaBuyer", testId: "quick-add-buyer" },
  { to: "/sellers", icon: UserPlus, key: "qaSeller", testId: "quick-add-seller" },
  { to: "/properties", icon: UserPlus, key: "qaProperty", testId: "quick-add-property" },
  { to: "/viewings", icon: UserPlus, key: "qaViewing", testId: "quick-add-viewing" },
  { to: "/rooms", icon: UserPlus, key: "qaRoom", testId: "quick-add-room" },
  { to: "/estimations", icon: ClipboardList, key: "qaEstimation", testId: "quick-add-estimation" },
];

export default function QuickAdd() {
  const { t } = useLang();
  return (
    <div className="flex flex-wrap gap-2 mb-6" data-testid="global-quick-add">
      {ITEMS.map(({ to, icon: Icon, key, testId }) => (
        <Link
          key={key}
          to={to}
          data-testid={testId}
          className="inline-flex items-center gap-1.5 bg-white border border-stone-200 hover:border-stone-500 hover:shadow-sm rounded-full px-3 py-1.5 text-xs font-medium text-stone-700 transition-all"
        >
          <Icon size={13} strokeWidth={1.75} className="text-[#9F8E7E]" />
          {t(key)}
        </Link>
      ))}
    </div>
  );
}
